// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"ClanTag__baseFont__2SRNS","baseColor":"ClanTag__baseColor__3Ybpe","baseFontFamily":"ClanTag__baseFontFamily__2PENz","tag":"ClanTag__tag__2me1N"};